export const svgDiagrams = () => {
  const rawDiagrams = [
    ...document.querySelectorAll('.language-mermaid'),
  ] as HTMLPreElement[];

  if (rawDiagrams.length) {
    rawDiagrams.forEach((rawDiagram) => {
      rawDiagram.style.fontSize = '0px';
    });

    const script = document.createElement('script');
    script.src =
      'https://cdn.jsdelivr.net/npm/mermaid@11.6.0/dist/mermaid.min.js';
    script.async = true;
    script.defer = true;
    script.onload = async () => {
      mermaid.initialize({ startOnLoad: false });
      await mermaid.run({
        querySelector: '.language-mermaid',
      });
    };
    document.head.appendChild(script);
  }
};
